import { RetryLink } from '@apollo/client/link/retry';

import { singleIdTokenRefresh } from '../_utils/singleIdTokenRefresh';

const RETRY_TIME = 5000;

export const retryLink = new RetryLink({
	delay: {
		initial: RETRY_TIME,
		max: 20,
		jitter: true
	},
	attempts: async (count, _, error) => {
		if (error) {
			if (count > 1) {
				return false;
			}

			const success = await singleIdTokenRefresh();
			return success;
		}

		if (count > 1) {
			return false;
		}

		return true;
	}
});
